
export const SET_MAP_CONFIG_MODE = 'SET_MAP_CONFIG_MODE'
export function setMapConfigMode(mapConfigMode) {
    return {
        type: SET_MAP_CONFIG_MODE,
        mapConfigMode
    }
}

export const SET_MAP_API_KEY = 'SET_MAP_API_KEY'
export function setMapApiKey(slideCurrentIndex, mapApiKey) {
    return {
        type: SET_MAP_API_KEY,
        slideCurrentIndex,
        mapApiKey
    }
}

export const SET_LIVE_API_KEY = 'SET_LIVE_API_KEY'
export function setLiveApiKey(slideCurrentIndex, liveApiKey) {
    return {
        type: SET_LIVE_API_KEY,
        slideCurrentIndex,
        liveApiKey
    }
}

export const SET_MAP_CONFIG = 'SET_MAP_CONFIG'
export function setMapConfig(slideCurrentIndex, config) {
    return {
        type: SET_MAP_CONFIG,
        slideCurrentIndex,
        config
    }
}






// WEBPACK FOOTER //
// ./src/actions/livefeed/steerpathMapActions.js